<template>
  <div v-click-outside="onClickOutside" class="zv-mb-header new-style">
    <div class="zv-mb-header__inner">
      <ul class="zv-mb-header__menu" role="menubar">
        <li
          v-for="(menuItem, i) in activeMenuItems"
          :key="i"
          role="menuitem"
          :class="[
            'zv-mb-header__menu-item',
            { 'is-route': checkIsRoute(menuItem) },
          ]"
        >
          <div :class="`menu-box el_${i}`" @click="checkMenu(menuItem)">
            <button v-if="hasChildren(menuItem)" class="zv-mb-header__menu-btn">
              {{ menuItem.title }}
            </button>
            <router-link
              v-else
              :to="menuItem.path"
              class="zv-mb-header__menu-link"
            >
              {{ menuItem.title }}
            </router-link>
          </div>
          <transition name="el-zoom-in-bottom">
            <ul
              v-if="hasChildren(menuItem) && activeMenuItemId === menuItem.id"
              v-moveinview
              class="zv-mb-header__submenu"
            >
              <li
                v-for="(submenuItem, j) in menuItem.children"
                :key="j"
                :class="[
                  'zv-mb-header__submenu-item',
                  { 'is-route': checkIsRoute(submenuItem) },
                ]"
              >
                <button
                  v-if="submenuItem.clickable"
                  class="zv-mb-header__menu-btn is-2"
                  @click="onSubItemClick(submenuItem)"
                >
                  {{ submenuItem.title }}
                </button>
                <router-link
                  v-else
                  :to="submenuItem.path"
                  class="zv-mb-header__menu-link is-2"
                  @click.native="activeMenuItemId = null"
                >
                  {{ submenuItem.title }}
                </router-link>
                <span
                  :class="[
                    'zv-mb-header__divider is-2',
                    { 'is-last': j === menuItem.children.length - 1 },
                  ]"
                />
              </li>
            </ul>
          </transition>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { mobileMenuItems } from './constants'
import ClickOutside from 'vue-click-outside'

export default {
  directives: {
    ClickOutside,
    moveinview: {
      inserted(el) {
        const rect = el?.getBoundingClientRect()
        const windowWidth =
          window.innerWidth || document.documentElement.clientWidth
        const isOutOfView = rect.right > windowWidth

        if (isOutOfView) {
          el.style.left = `${windowWidth - rect.right}px`
        }
      },
    },
  },
  props: {
    hide: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeMenuItemId: null,
      menuItems: mobileMenuItems,
    }
  },
  computed: {
    userType() {
      return this.userInfo.user_type
    },
    activeMenuItems() {
      let menuItems = []

      if (this.hide && this.userType === 4) {
        menuItems = this.menuItems['hidden']
      } else {
        const types = ['admin', 'exporter', 'dispatcher', 'contragent']
        const activeType = types[this.userType - 1]

        menuItems = this.menuItems[activeType]
      }

      return menuItems
    },
  },
  created() {
    this.filLibs()
  },
  methods: {
    ...mapActions({
      logout: 'auth/authLogout',
    }),
    checkMenu(c) {
      if (this.hasChildren(c)) {
        this.onItemClick(c)
      } else {
        this.activeMenuItemId = null
      }
    },
    hasChildren(c) {
      return c.children && c.children.length
    },
    checkIsRoute(c) {
      const route = this.$route.fullPath

      if (this.hasChildren(c)) {
        const item = c.children.find(ch => ch.path === route)

        return Boolean(item)
      }

      return c.path && c.path === route
    },
    onItemClick(item) {
      if (this.activeMenuItemId && this.activeMenuItemId === item.id) {
        this.activeMenuItemId = null

        return
      }
      this.activeMenuItemId = item.id
    },
    onSubItemClick(item) {
      if (!item || !item.action) {
        return
      }
      this.activeMenuItemId = null
      switch (item.action) {
        case 'logout':
          this.confirmLogout()
          break
        default:
          break
      }
    },
    onClickOutside() {
      this.activeMenuItemId = null
    },
    confirmLogout() {
      this.$confirm('Вы уверены что хотите выйти', 'Warning', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      })
        .then(() => {
          this.logout()
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss">
$activeColor: rgb(255, 255, 255);

.zv-mb-header {
  position: fixed;
  background-color: rgb(64, 158, 255);
  color: #fff;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 45px;
  font-size: 14px;

  @media screen and(min-width: 360px) {
    font-size: 16px;
    height: 50px;
  }

  &__inner {
    position: relative;
    width: 100%;
    height: 100%;
  }

  &__menu {
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    display: flex;
    background-color: rgb(64, 158, 255);
  }

  &__menu-item {
    flex-grow: 1;
    position: relative;
    &.is-route {
      color: $activeColor;
      text-decoration: underline;
    }
  }

  &__submenu {
    position: absolute;
    left: 5px;
    bottom: calc(100% + 2px);
    z-index: 9;
    max-width: 95vw;
    margin: 0;
    padding: 0;
    list-style-type: none;
    display: block;
    background-color: inherit;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;

    &.is-right {
      right: 5px;
      left: auto;
    }
  }

  &__submenu-item {
    min-height: 45px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #fff;

    @media screen and(min-width: 360px) {
      min-height: 50px;
      padding: 0 20px;
    }

    &.is-route {
      color: $activeColor;
      text-decoration: underline;
    }
  }

  &__menu-link {
    color: inherit;
    text-decoration: none;
    text-align: center;
    // height: 100%;
    flex-grow: 1;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    // display: flex;
    // align-items: center;
    // justify-content: center;

    &.is-2 {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      max-width: 100%;
      justify-content: flex-start;
      text-align: left;
    }
  }

  &__menu-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    background-color: transparent;
    border: none;
    outline: none;
    font-size: inherit;
    font-family: inherit;
    height: 100%;
    flex-grow: 1;
    color: inherit;

    &:visited {
      color: #fff !important;
    }
    &.is-2 {
      width: 100%;
      max-width: 100%;
      justify-content: flex-start;
      text-align: left;
    }
  }

  &__divider {
    width: 1px;
    flex: 00 1px;
    height: 50%;
    background-color: #fff;

    &.is-2 {
      width: 100%;
      height: 1px;
      flex: 0 0 1px;
      align-self: flex-start;
    }
    &.is-last {
      display: none;
    }
  }
}
.el-message-box {
  max-width: 90%;
}
</style>
<style lang="sass">
$backColor: #FFFFFF
$textColor: #333333

.new-style
  background-color: $backColor
  border-top: 2px solid #409EFF
  color: #333
  height: 52px
  .zv-mb-header
    &__menu
     background-color: $backColor
    &__menu-item
      background-color: $backColor
      &.is-route
        color: $textColor
        text-decoration: none
        >.menu-box
          button, a
            font-weight: bold
      >.menu-box
        position: relative
        width: 100%
        height: 100%
        &:before
          content: ''
          position: absolute
        &.el_0:before
          top: 10px
          left: calc(50% - 9px)
          width: 17px
          height: 18px
          background: url('~@/assets/img/zayavki.png')
          background-size: contain
        &.el_1:before
          top: 12px
          left: calc(50% - 18px)
          width: 36px
          height: 17px
          background: url('~@/assets/img/my_auto.png')
          background-size: contain
        &.el_2:before
          top: 7px
          left: calc(50% - 12px)
          width: 24px
          height: 21px
          background: url('~@/assets/img/drivers.png')
          background-size: contain
        &.el_3:before
          top: 8px
          left: calc(50% - 14px)
          width: 28px
          height: 20px
          background: url('~@/assets/img/profile.png')
          background-size: contain
        >.zv-mb-header
          &__menu-btn, &__menu-link
            padding: 25px 0 5px
            margin: 0 auto
    &__submenu
      box-shadow: 0 0 5px #ccc
    &__submenu-item
      color: $textColor
      &.is-route
        color: $textColor
        text-decoration: none
        button, a
          font-weight: bold
    &__divider
      &.is-2
        background-color: #ccc
</style>
